<template>
  <div class="container-fluid">
    <div class="row mb-5 bg-white rounded-3">
      <div class="heading mt-5">
        <router-link class="btn btn-success ms-4" to="/admin/search-witness"><font-awesome-icon icon="backward" class="text-white back-icon"/></router-link>
        <h4 class="p-2 text-center mb-3 mt-3 fw-bold" style="font-family: Sylfaen; color: #077747">Add Outside
          Witness</h4>
        <hr class="style-eight m-auto">
      </div>
      <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
        <div class="row">
          <div class="col-md-8 m-auto">
            <b-form-group label="Witness Name">
              <b-form-input
                  id="name_witness"
                  placeholder="Enter Witness name"
                  v-model="formData.name"
              >
              </b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-8 m-auto">
            <b-form-group label="Relation With Witness">
              <b-form-input
                  id="relation-witness"
                  placeholder="Enter Witness Relations"
                  v-model="formData.relationWithUser"
              >
              </b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-8 m-auto">
            <b-form-group label="Mobile" label-for="mobile">
              <b-form-input
                  id="mobile"
                  placeholder="Enter Mobile"
                  v-model="formData.mobile"
              >
              </b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-8 m-auto">
            <b-form-group label="Email" label-for="email">
              <b-form-input
                  id="email"
                  placeholder="Enter email"
                  v-model="formData.email"
              >
              </b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-8 m-auto">
            <b-form-group label="Date Of Birth" label-for="dob">
              <b-form-input
                  id="email"
                  placeholder="Enter dob"
                  v-model="formData.dob"
              >
              </b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-8 m-auto">
            <b-form-group label="Present Address" label-for="present_address">
              <b-form-textarea
                  rows="5"
                  id="present_address"
                  placeholder="Enter Present Address"
                  v-model="formData.presentAddress"
              >
              </b-form-textarea>
            </b-form-group>
          </div>
          <div class="col-md-8 m-auto">
            <b-form-group label="Permanent Address" label-for="permanent_address">
              <b-form-textarea
                  cols="1"
                  rows="5"
                  id="name"
                  placeholder="Enter Permanent Address"
                  v-model="formData.permanentAddress"
              >
              </b-form-textarea>
            </b-form-group>
          </div>
          <div class="col-md-8 button d-flex justify-content-end gap-2 m-auto mb-5">
            <button type="submit" class="btn btn-outline-success">Save Witness</button>
            <button class="btn btn-outline-danger">Cancel</button>
          </div>
        </div>
      </b-form>
    </div>


  </div>
</template>

<script>
import apiRepository from "@/services/ApiRepository";
import { toast } from "vue3-toastify"

export default {
  name: 'outsideWitness',
  data() {
    return {
      formData: {
        relationWithUser: '',
        name: '',
        mobile: '',
        email: '',
        dob: '',
        presentAddress: '',
        permanentAddress: '',
      }
    }
  },
  methods: {
    onSubmit() {
      apiRepository.saveWitness(this.formData).then(res => {
        if (res.status == 200) {
          toast.success(res.data || "Successfully Assign Witness")
        }else {
          toast.error(res.data || "Invalid Data")
        }

      })
    },
    onReset() {

    }
  }
}
</script>

<style>
hr.style-eight {
  overflow: visible; /* For IE */
  padding: 0;
  border: none;
  border-top: medium double #007704;
  color: #007704;
  text-align: center;
}

hr.style-eight:after {
  content: "§";
  display: inline-block;
  position: relative;
  top: -0.9em;
  font-size: 1.5em;
  padding: 0 0.25em;
  background: #ffffff;
}
</style>